// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require("babel-polyfill");

// import "babel-polyfill"

import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource';
import Api from './components/common/ApiFactory.js'
import Functions from './components/common/functions.js'
import Filters from './components/common/filters.js'
import Dao from './components/common/dao/dao.js'
// import VueHtml2Canvas from 'vue-html2canvas'

require('./assets/style.css')
require('./assets/addition.css')
require('./assets/font/iconfont.css')

import './assets/font3/iconfont.js'
import './assets/font3/icon.css'
require('./assets/font2/iconfont.css')





Vue.config.productionTip = false

Vue.prototype.Api=Api;

var dao = new Dao.Dao('2018lmyDao');
Vue.prototype.dao=dao;

Vue.prototype.$user={}
 
// Vue.use(VueHtml2Canvas);

Vue.use(VueResource);
Vue.use(Functions);
Vue.use(Filters);


/* eslint-disable no-new */
new Vue({
  data:{
    myImg:''
  },
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js